import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { signInWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../firebase-config";
import "../../styles/adminlogin.css";

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      // Use modular Firebase v9+ function for authentication
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Check if the user is an authorized admin
      if (user.email === 'shazah7606@gmail.com' || user.email === 'paadmin@gmail.com') {
        alert("Login Successful");
        navigate('/admin/dashboard'); // Redirect to admin dashboard
      } else {
        setError('Unauthorized user');
      }
    } catch (err) {
      setError(err.message || "An error occurred. Please try again.");
    }
  };

  const handleForgotPassword = async () => {
    if (!email) {
      setError('Please enter your email address');
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      setError('Password reset email sent! Please check your inbox.');
    } catch (err) {
      setError(err.message || "Error sending reset email.");
    }
  };

  return (
    <div className="admin-login">
      <h2>Admin Login</h2>
      <form onSubmit={handleLogin}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            setError(''); // Clear error on typing
          }}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            setError(''); // Clear error on typing
          }}
          required
        />
        <button type="submit">Login</button>
      </form>
      <div className="auth-links">
        <button
          type="button"
          onClick={handleForgotPassword}
          className="forgot-password"
        >
          Forgot Password?
        </button>

        {error && <p className="error-message">{error}</p>}
      </div>
    </div>
  );
};

export default AdminLogin;
